import * as cache from 'state/cache'
import { appendComposerImages } from './composerImages'

export function fileHandler(file: File, answerId: string) {
    if (file && answerId) {
        let params
        if (file.type.includes('image')) {
            const currentAnswer = cache.getCachedAnswer(answerId) || {}
            const result = appendComposerImages(currentAnswer, [file], selectedFile =>
                URL.createObjectURL(selectedFile),
            )
            params = result.patch
            cache.updateCachedAnswer(answerId, params)
            return result
        } else if (file.type.includes('video')) {
            const videoUrl = URL.createObjectURL(file)
            // Store preview URL and type on the draft answer cache (no localStorage).
            // Upload runs in background and server answer will temporarily copy these fields for immediate playback.
            params = {
                recording_url: videoUrl,
                recording_content_type: file.type || 'video/mp4',
                original_recording_type: file.type || 'video/mp4',
            }
        } else {
            params = {
                // Do not store the raw File object in cache to avoid memory pressure on mobile
                file_urls: [file].map(f => {
                    const localUrl = URL.createObjectURL(f)
                    try {
                        // Store local blob URL so we can use it as a preferred source after posting
                        // Keyed by answerId to avoid collisions across answers
                        localStorage.setItem(`local3d:${answerId}:${f.name}`, localUrl)
                    } catch (e) {}
                    return { name: f.name, url: localUrl, content_type: f.type }
                }),
            }
        }
        cache.updateCachedAnswer(answerId, params)
    }

    return { accepted: [], rejectedCount: 0, patch: null }
}
